(function () {
  const initImageSliders = () => {
    const focusableSelector =
      'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]';

    document.querySelectorAll('[data-slider]').forEach((slider) => {
      const track = slider.querySelector('[data-slider-track]');
      const slides = Array.from(slider.querySelectorAll('[data-slide]'));
      if (!track || slides.length === 0) return;

      const perViewSetting = parseInt(slider.getAttribute('data-slides-per-view'), 10) || 1;
      let perView = Math.max(1, Math.min(perViewSetting, slides.length));
      let index = 0;
      let timer = null;

      const dotsWrap = slider.querySelector('[data-dots]');
      let dots = [];

      const maxIndex = () => Math.max(0, slides.length - perView);
      const clamp = (val) => Math.max(0, Math.min(val, maxIndex()));

      const updateSlideAccessibility = () => {
        const start = index;
        const end = index + perView;

        slides.forEach((slide, slideIndex) => {
          const isVisible = slideIndex >= start && slideIndex < end;
          slide.setAttribute('aria-hidden', isVisible ? 'false' : 'true');

          slide.querySelectorAll(focusableSelector).forEach((el) => {
            if (isVisible) {
              if (el.hasAttribute('data-a11y-tabindex')) {
                const original = el.getAttribute('data-a11y-tabindex');
                if (original === '') {
                  el.removeAttribute('tabindex');
                } else {
                  el.setAttribute('tabindex', original);
                }
                el.removeAttribute('data-a11y-tabindex');
              }
              return;
            }

            if (!el.hasAttribute('data-a11y-tabindex')) {
              el.setAttribute('data-a11y-tabindex', el.getAttribute('tabindex') ?? '');
            }
            el.setAttribute('tabindex', '-1');
          });
        });
      };

      const stopAutoplay = () => {
        if (timer) clearInterval(timer);
        timer = null;
      };

      const updateDots = () => {
        if (!dotsWrap || dots.length === 0) return;
        dots.forEach((dot, i) => {
          const isActive = i === index;
          dot.classList.toggle('bg-gray-900', i === index);
          dot.classList.toggle('bg-gray-300', i !== index);
          dot.classList.toggle('w-6', i === index);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      };

      const update = () => {
        index = clamp(index);
        track.style.transform = `translateX(calc(-${index * (100 / perView)}% - ${index * 1}rem))`;
        updateSlideAccessibility();
        updateDots();
      };

      const buildDots = () => {
        if (!dotsWrap) return;
        dotsWrap.setAttribute('role', 'group');
        dotsWrap.setAttribute('aria-label', 'Slider navigation');
        dotsWrap.innerHTML = '';
        const count = maxIndex() + 1;
        dots = Array.from({ length: count }).map((_, i) => {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'h-2 w-2 theme-border-radius bg-gray-300 transition';
          btn.setAttribute('aria-label', `Go to slide ${i + 1}`);
          btn.addEventListener('click', () => {
            index = i;
            update();
          });
          dotsWrap.appendChild(btn);
          return btn;
        });
        updateDots();
      };

      const applyWidths = () => {
        perView = window.matchMedia('(max-width: 1023px)').matches
          ? 1
          : Math.max(1, Math.min(perViewSetting, slides.length));

        const width = 100 / perView;
        slides.forEach((slide) => {
          slide.style.width = `${width}%`;
        });

        update();
        buildDots();
      };

      const autoplay = slider.getAttribute('data-autoplay') === 'true';
      const delay = parseInt(slider.getAttribute('data-autoplay-delay'), 10) || 5000;
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const startAutoplay = () => {
        stopAutoplay();
        if (!autoplay || prefersReducedMotion || slides.length <= perView) return;

        timer = setInterval(() => {
          index = index >= maxIndex() ? 0 : index + 1;
          update();
        }, Math.max(1000, delay));
      };

      const prev = slider.querySelector('[data-prev]');
      const next = slider.querySelector('[data-next]');
      if (prev) {
        prev.addEventListener('click', () => {
          index -= 1;
          update();
        });
      }
      if (next) {
        next.addEventListener('click', () => {
          index += 1;
          update();
        });
      }

      let startX = 0;
      let isDown = false;
      const onPointerDown = (event) => {
        isDown = true;
        startX = event.clientX ?? 0;
      };
      const onPointerUp = (event) => {
        if (!isDown) return;
        isDown = false;
        const endX = event.clientX ?? 0;
        const delta = endX - startX;
        if (Math.abs(delta) < 40) return;

        index += delta < 0 ? 1 : -1;
        update();
      };

      track.addEventListener('pointerdown', onPointerDown);
      window.addEventListener('pointerup', onPointerUp);
      track.addEventListener(
        'touchstart',
        (event) => {
          const touch = event.touches[0];
          if (!touch) return;
          onPointerDown({ clientX: touch.clientX });
        },
        { passive: true }
      );
      track.addEventListener(
        'touchend',
        (event) => {
          const touch = event.changedTouches[0];
          if (!touch) return;
          onPointerUp({ clientX: touch.clientX });
        },
        { passive: true }
      );

      slider.addEventListener('mouseenter', stopAutoplay);
      slider.addEventListener('mouseleave', startAutoplay);
      slider.addEventListener('focusin', stopAutoplay);
      slider.addEventListener('focusout', (event) => {
        if (event.relatedTarget && slider.contains(event.relatedTarget)) return;
        startAutoplay();
      });

      applyWidths();
      startAutoplay();
      window.addEventListener('resize', () => {
        applyWidths();
        startAutoplay();
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initImageSliders);
  } else {
    initImageSliders();
  }
})();
